import { TableBody } from 'components/Table/TableBody/TableBody';
import { queryKeys } from 'utils/query';
import { LogsOverviewColumns } from 'components/Table/Columns/LogsOverviewColumns';
import { useTranslation } from 'react-i18next';
import { TableConfig } from 'models/general';
import { BsPlus } from 'react-icons/bs';
import { PortalButton } from 'components/Button/PortalButton';
import { getLogsTableRecords } from 'services/logs';
import { LogsList } from 'models/patientMedicalEvent';
import { useDrawerContext } from 'context/hooks';
import { usePatient } from 'hooks/api/useUser';
import { useParams } from 'react-router-dom';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';
import { AddLogDrawer } from './AddLogDrawer';

const logsConfig: TableConfig = {
  queryKey: queryKeys.patientMedicalEvents,
};

export const LogsOverviewList = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patientData } = usePatient({ patientId });

  const handleAddLogClick = () => {
    openDrawer({
      content: <AddLogDrawer patientData={patientData} />,
      title: t('add_log_label'),
    });
  };

  return (
    <TableBody<LogsList>
      h={140}
      getData={getLogsTableRecords}
      getColumns={LogsOverviewColumns}
      config={logsConfig}
      titleBar={
        <PaperHeader titleKey={'patients_logs_title'}>
          <PortalButton
            size={'xs'}
            Icon={BsPlus}
            variant={'outline'}
            onClick={handleAddLogClick}
            label={t('add_log_label')}
          />
        </PaperHeader>
      }
      loadToInfinity={false}
      saveFiltersForLater={false}
    />
  );
};
